/**
 * 图片上传：优先后台 /mgmt/file/uploadImageCompress（含 EXIF 纠正），失败回退 /file/upload
 *（小程序走 /pc/file/uploadImageCompress，互不影响；不做浏览器端预压缩）
 */
import requestUrl from "./requestUrl";

function buildForm(file, fields) {
  const form = new FormData();
  form.append("file", file);
  if (fields && typeof fields === "object") {
    Object.keys(fields).forEach((k) => {
      if (fields[k] != null && fields[k] !== "") {
        form.append(k, fields[k]);
      }
    });
  }
  return form;
}

/**
 * @param {*} body 接口 JSON 根对象
 * @returns {{ ok: boolean, path?: string, data?: *, msg?: string }}
 */
export function parseImageUploadBody(body) {
  if (!body || typeof body !== "object") {
    return { ok: false, msg: "上传失败" };
  }
  const code = body.code;
  const uploadOk =
    (code === 200 || code === 1 || code === 0 || body.status == 1) &&
    body.data != null &&
    !(typeof body.data === "string" && body.data === "null");
  if (!uploadOk) {
    return { ok: false, msg: body.msg || "上传失败" };
  }
  const d = body.data;
  const path =
    typeof d === "string"
      ? d
      : (d && (d.path || d.url || d.fileUrl || d.fullPath)) || "";
  if (!path) {
    return { ok: false, msg: "未返回图片地址" };
  }
  return { ok: true, path: String(path).trim(), data: d };
}

/**
 * @param {Function} httpsFn 一般为 this.$https
 * @param {File|Blob} file
 * @param {object} [options]
 * @param {object} [options.api] requestUrl.api
 * @param {string} [options.compressUrl]
 * @param {string} [options.uploadUrl]
 * @param {string|number} [options.no]
 * @param {object} [options.fields] 额外 FormData 字段（每次请求重建）
 * @returns {Promise<{ ok: boolean, path?: string, data?: *, body?: *, msg?: string, usedFallback?: boolean }>}
 */
export async function uploadImageWithCompressFallback(httpsFn, file, options = {}) {
  if (!httpsFn || !file) {
    return { ok: false, msg: "上传参数无效" };
  }
  const api = options.api || requestUrl.api || {};
  const compressUrl = options.compressUrl || api.uploadImgCompress;
  const uploadUrl = options.uploadUrl || api.uploadImg;
  const no =
    options.no != null
      ? options.no
      : `${Date.now()}_${Math.round(Math.random() * 1000)}`;
  const fields = Object.assign({ no: String(no) }, options.fields || {});

  const tryOnce = async (url) => {
    if (!url) return { ok: false, msg: "上传地址无效" };
    try {
      const form = buildForm(file, fields);
      const res = await httpsFn(url, form, "POST");
      const body = res && res.data;
      const parsed = parseImageUploadBody(body);
      if (parsed.ok) {
        return { ok: true, path: parsed.path, data: parsed.data, body };
      }
      return { ok: false, msg: parsed.msg || "上传失败", body };
    } catch (e) {
      return { ok: false, msg: "上传失败" };
    }
  };

  let result = await tryOnce(compressUrl);
  if (result.ok) {
    return result;
  }

  console.warn(
    "[uploadImageWithCompressFallback] compress fail, fallback to uploadImg",
    result
  );
  result = await tryOnce(uploadUrl);
  if (result.ok) {
    return Object.assign({}, result, { usedFallback: true });
  }
  return result;
}

export default uploadImageWithCompressFallback;



// WEBPACK FOOTER //
// ./src/util/uploadImageWithCompressFallback.js